module.exports = __webpack_public_path__ + "static/media/pupils.0b6beb84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reportcentre/pupils.jpg
// module id = 2937
// module chunks = 0